/**
 * SessionExtendButton
 *
 * Triggers a session extension for guides and customers. NEVER rendered for
 * internal staff — their 2-hour session is a hard limit per MVP 1.15 V2 spec.
 *
 * SCRUM-366 | MVP 1.15 V2 Epic 4
 */

import React from 'react';

/**
 * @param {{
 *   onExtend: () => void,
 *   disabled?: boolean,
 * }} props
 */
export default function SessionExtendButton({ onExtend, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onExtend}
      disabled={disabled}
      data-testid="session-extend-button"
      className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Extend Session
    </button>
  );
}
